/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';
// @ts-expect-error untyped import
import { FieldError } from '@checkout/react-components';

// Internal modules
import {
  ComponentContainer,
  dialingCodeStyles,
  InputsContainer,
  PhoneInputsContainer,
  streamlineDialingCodeStyles,
} from './styles';
import type { PhoneContainerProps } from './types';

export const PhoneContainer = ({
  canDialingCodeChange,
  children,
  isStreamlineExperience = false,
  phone,
  phoneType,
  withPhoneType,
}: PhoneContainerProps): JSX.Element => {
  if (!withPhoneType) {
    if (isStreamlineExperience && canDialingCodeChange) {
      return (
        <ComponentContainer>
          <PhoneInputsContainer
            canDialingCodeChange={canDialingCodeChange}
            css={[canDialingCodeChange && streamlineDialingCodeStyles]}
            phone={phone}
          >
            {children}
          </PhoneInputsContainer>
        </ComponentContainer>
      );
    }
    // @ts-expect-error this is likely a possible bug / mistake
    // Possible what is returned is not an element since children is not strict
    return children;
  }

  return (
    <ComponentContainer>
      <InputsContainer
        canDialingCodeChange={canDialingCodeChange}
        css={[canDialingCodeChange && dialingCodeStyles]}
        phone={phone}
        phoneType={phoneType}
      >
        {children}
      </InputsContainer>

      {phone.displayError && (
        <FieldError id="phone-error">{phone.error}</FieldError>
      )}
    </ComponentContainer>
  );
};
